/**
 * @generated SignedSource<<d1234cc75295f4d8aaea69f124c0fbdb>>
 * @relayHash 0a96cc03e37bbf3867e6744daa23017e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID efcaebfa892eb7b5401d08c3aae85bece7d435ed2ea26e7a97b3ebeb61c6ce13

import type { ConcreteRequest } from 'relay-runtime';
export type useFeedRecommendationsFeedRecommendationQuery$variables = Record<PropertyKey, never>;
export type useFeedRecommendationsFeedRecommendationQuery$data = {
  readonly getRecommendedFeedUserConfig: {
    readonly recommendedPeople: ReadonlyArray<{
      readonly score: number;
      readonly user: {
        readonly displayName: string | null | undefined;
        readonly id: string | null | undefined;
        readonly isActive: boolean | null | undefined;
        readonly photos: ReadonlyArray<{
          readonly isPrimary: boolean | null | undefined;
          readonly value: string | null | undefined;
        } | null | undefined> | null | undefined;
        readonly title: string | null | undefined;
      } | null | undefined;
    }>;
    readonly recommendedSpaces: ReadonlyArray<{
      readonly score: number;
      readonly space: {
        readonly icon: {
          readonly path: string;
        } | null | undefined;
        readonly id: string | null | undefined;
        readonly key: string | null | undefined;
        readonly name: string | null | undefined;
      } | null | undefined;
    }>;
  } | null | undefined;
  readonly userPreferences: {
    readonly feedRecommendedUserSettingsDismissTimestamp: string;
  } | null | undefined;
};
export type useFeedRecommendationsFeedRecommendationQuery = {
  response: useFeedRecommendationsFeedRecommendationQuery$data;
  variables: useFeedRecommendationsFeedRecommendationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "score"
},
v1 = {
  "kind": "ScalarField",
  "name": "id"
},
v2 = [
  {
    "concreteType": "RecommendedFeedUserConfig",
    "kind": "LinkedField",
    "name": "getRecommendedFeedUserConfig",
    "plural": false,
    "selections": [
      {
        "concreteType": "RecommendedSpaceItem",
        "kind": "LinkedField",
        "name": "recommendedSpaces",
        "plural": true,
        "selections": [
          (v0/*: any*/),
          {
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "kind": "ScalarField",
                "name": "key"
              },
              {
                "kind": "ScalarField",
                "name": "name"
              },
              {
                "concreteType": "Icon",
                "kind": "LinkedField",
                "name": "icon",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "path"
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "concreteType": "RecommendedPeopleItem",
        "kind": "LinkedField",
        "name": "recommendedPeople",
        "plural": true,
        "selections": [
          (v0/*: any*/),
          {
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "kind": "ScalarField",
                "name": "title"
              },
              {
                "kind": "ScalarField",
                "name": "displayName"
              },
              {
                "kind": "ScalarField",
                "name": "isActive"
              },
              {
                "concreteType": "AtlassianUserPhoto",
                "kind": "LinkedField",
                "name": "photos",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "value"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "isPrimary"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  {
    "concreteType": "UserPreferences",
    "kind": "LinkedField",
    "name": "userPreferences",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "feedRecommendedUserSettingsDismissTimestamp"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "useFeedRecommendationsFeedRecommendationQuery",
    "selections": (v2/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "useFeedRecommendationsFeedRecommendationQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "0a96cc03e37bbf3867e6744daa23017e",
    "id": "efcaebfa892eb7b5401d08c3aae85bece7d435ed2ea26e7a97b3ebeb61c6ce13",
    "metadata": {},
    "name": "useFeedRecommendationsFeedRecommendationQuery",
    "operationKind": "query",
    "text": "query useFeedRecommendationsFeedRecommendationQuery{getRecommendedFeedUserConfig{recommendedSpaces{score,space{id,key,name,icon{path}}},recommendedPeople{score,user{id,title,displayName,isActive,photos{value,isPrimary}}}},userPreferences{feedRecommendedUserSettingsDismissTimestamp}}"
  }
};
})();

(node as any).hash = "f23db13107460d6f583073e645fa5821";

export default node;
